import Dexie from "dexie";

export const db = new Dexie("planificadorOffline");

db.version(9).stores({
  sync_meta: "recurso, estado, ultimaSync",
  servicios_sync: "nombre, endpoint",

  almacenes: "__offlineId, almacen, rut, id",
  clientes: "__offlineId, codigo, rut, razonSocial",
  productos: "__offlineId, codigo, descripcion",
  precios: "__offlineId, lista_precio, articulo, precio",
  contactos: "__offlineId, codigo, id",
  lista_precios: "__offlineId, codigo",
  condicion_pagos: "__offlineId, id",
  condiciones: "__offlineId, id",
  stock: "__offlineId, almacen, articulo",
  stock_drp: "__offlineId, id, codigoProducto, almacen",
  dato_clientes: "__offlineId, codigo, rut, estado",
  deuda_clientes: "__offlineId, codigo, fecha, atraso",
  obras: "__offlineId, codigo, id",
  validezs: "__offlineId, id",
  estados: "__offlineId, id",
  causas: "__offlineId, id",
  cierres: "__offlineId, id",
  competencias: "__offlineId, id",

  offline_auth: "username",

  offline_cotizaciones:
    "++idLocal, folioLocal, codigoCliente, tipoDocumento, estadoSync, fechaCreacion",
  offline_cotizacion_detalles: "++idLocal, idCotizacionLocal, codigoProducto",
  offline_outbox: "++idLocal, tipo, estado, fechaCreacion",
});
